import { useDocStore } from '../../stores/DocStore'
import { useCurrentLayer } from '../../hooks/useCurrentLayer'
import { LayerCompleteMessage } from './LayerCompleteMessage'
import { DocCompleteMessage } from './DocCompleteMessage'

export const CompleteMessage = () => {
  const docStore = useDocStore()
  const currentLayer = useCurrentLayer({ articleKey: docStore.articleId })

  if (!currentLayer) return null

  return currentLayer.is_main ? <DocCompleteMessage /> : <LayerCompleteMessage layer={currentLayer} />
}
